/**
 * Build a clinic list ({ id, name }) from a clinicGrants map, sorted
 * case-insensitively by name. Use everywhere a clinic list is shown or a
 * default clinic is picked so ordering is consistent app-wide.
 */
export default function getSortedClinicList(clinicGrants) {
    return Object.keys(clinicGrants || {})
        .map((clinicId) => ({
            id: `${clinicId}`,
            name: clinicGrants[clinicId]?.meta?.name || ''
        }))
        .sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }));
}
